"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemsCounter = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component for displaying number of items on a listing page.
 * Renders if `text` has thruthy value.
 */
const ItemsCounter = ({
  text,
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!text) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
    className: className,
    "data-testid": getTestId(_constants.ITEMS_COUNTER),
    fontWeight: "bold",
    textAlign: "center",
    color: "textPrimary",
    children: text
  });
};
exports.ItemsCounter = ItemsCounter;
